var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 25C36.6667 31.45 31.45 36.6667 25 36.6667L26.75 33.75",
    stroke: "#494C50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 14.9999C3.33301 8.54992 8.54967 3.33325 14.9997 3.33325L13.2497 6.24992",
    stroke: "#494C50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.833 7.4165L29.4663 11.2498L36.033 7.43319",
    stroke: "#494C50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4668 18.0332V11.2332",
    stroke: "#494C50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9 3.68325L23.9 5.89985C23 6.39985 22.25 7.6665 22.25 8.69983V12.9332C22.25 13.9666 22.9833 15.2332 23.9 15.7332L27.9 17.9499C28.75 18.4332 30.15 18.4332 31.0167 17.9499L35.0166 15.7332C35.9166 15.2332 36.6667 13.9666 36.6667 12.9332V8.69983C36.6667 7.6665 35.9333 6.39985 35.0166 5.89985L31.0167 3.68325C30.1667 3.21659 28.7667 3.21659 27.9 3.68325Z",
    stroke: "#494C50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91602 25.75L10.5327 29.5833L17.116 25.7667",
    stroke: "#494C50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5322 36.3667V29.5667",
    stroke: "#494C50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98301 22.0167L4.98302 24.2333C4.08302 24.7333 3.33301 26 3.33301 27.0333V31.2667C3.33301 32.3001 4.06635 33.5667 4.98302 34.0667L8.98301 36.2834C9.83301 36.7667 11.233 36.7667 12.0997 36.2834L16.0997 34.0667C16.9997 33.5667 17.7497 32.3001 17.7497 31.2667V27.0333C17.7497 26 17.0163 24.7333 16.0997 24.2333L12.0997 22.0167C11.233 21.5501 9.83301 21.5501 8.98301 22.0167Z",
    stroke: "#494C50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert);
export default __webpack_public_path__ + "static/media/convert.6eb8482add4fb6d16608091e9a4e090a.svg";
export { ForwardRef as ReactComponent };